import "./panel.css";
import { PanelProps } from "./panel.props";
import { Header } from "../header";

const Panel: React.FC<PanelProps> = ({ children = <></>, header = true }) => {
  return (
    <div className={`panel-container ${header ? "header" : "withoutHeader"}`}>
      {header && <Header />}
      {children}
    </div>
  );
};

export default Panel;
